// Laagstijlen die door meer dan één kaart gebruikt worden (CAMap en de
// workspace-kaart), zodat dezelfde soort data er overal hetzelfde uitziet.

import {
  CircleLayerSpecification,
  ExpressionSpecification,
  FillLayerSpecification,
  LineLayerSpecification,
} from "maplibre-gl";

export const circleSearchStyle: Partial<CircleLayerSpecification> = {
  paint: {
    "circle-radius": ["interpolate", ["linear"], ["zoom"], 4, 0.5, 14, 4],
    "circle-color": "rgba(255, 10, 10, 0.5)",
  },
};

// De percelen die aan het actieve filter voldoen.
export const parcelMatchStyle: Partial<FillLayerSpecification> = {
  paint: {
    "fill-color": "rgba(255, 10, 10, 0.35)",
    "fill-outline-color": "rgb(200, 0, 0)",
  },
};

// Percelen van een verkenning (property `exploration`) zijn lichtblauw met een
// stippelrand, die van een project geel met streepjes: dezelfde kleuren als het
// label in workspaces/kind.ts. Een tag kleurt de vulling, maar de rand van een
// verkenning blijft blauw, zodat je hem altijd herkent.
const isExploration: ExpressionSpecification = ["boolean", ["get", "exploration"], false];
const isSelected: ExpressionSpecification = ["boolean", ["get", "selected"], false];

export const workspaceFillStyle: Partial<FillLayerSpecification> = {
  paint: {
    "fill-outline-color": [
      "case",
      isExploration,
      "rgb(2, 132, 199)",
      [
        "coalesce",
        ["get", "tagOutline"],
        ["case", isSelected, "rgb(202, 138, 4)", "rgb(234, 179, 8)"],
      ],
    ],
    "fill-color": [
      "coalesce",
      ["get", "tagFill"],
      [
        "case",
        isExploration,
        ["case", isSelected, "rgba(56, 189, 248, 0.45)", "rgba(56, 189, 248, 0.15)"],
        ["case", isSelected, "rgba(253, 224, 71, 0.5)", "rgba(253, 224, 71, 0.15)"],
      ],
    ],
  },
};

export const workspaceStyle: Partial<LineLayerSpecification> = {
  paint: {
    "line-color": [
      "case",
      isExploration,
      ["case", isSelected, "rgb(3, 105, 161)", "rgb(2, 132, 199)"],
      [
        "coalesce",
        ["get", "tagOutline"],
        ["case", isSelected, "rgb(146, 64, 14)", "rgb(202, 138, 4)"],
      ],
    ],
    "line-width": ["case", isSelected, 3, 2],
    // Een array kan in een expressie alleen als literal.
    "line-dasharray": ["case", isExploration, ["literal", [1, 1.5]], ["literal", [3, 2]]],
  },
};
